import {EntityType} from '../../types';

export const entitiesWithFolders: EntityType[] = ['teachers', 'specialists'];
